import { Box } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { Skeleton } from '@/components/skeleton/styles'

export const TaxWorkerDetailsLoading: FC = () => {
  return (
    <Box
      $display="flex"
      $direction="column"
      $gap={4}
      $align="initial"
      $fullWidth
    >
      <Skeleton $height={76} />
      <Skeleton $height={200} />
    </Box>
  )
}
